// @mui
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Fragment } from 'react';
// hooks
import useResponsive from '../../../hooks/useResponsive';

export default function NegotiateSuggestAmendBeforeRejectDialog({ isOpen, closeDialog, goReject, goComment }) {
  const smUp = useResponsive('up', 'sm');;

  const reject = async () => {
    closeDialog();
    goReject();
  };

  const modify = async () => {
    closeDialog();
    goComment();
  };

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogTitle sx={{ mb: 1}}>
        잠깐만요, 이런 경우에는 계약 조건을 수정할 수 있어요
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          1. 업무 시작 일자가 너무 늦거나 빨라요
        </DialogContentText>
        <DialogContentText>
          2. 업무 투입 시간이 너무 적어요
        </DialogContentText>
        <DialogContentText>
          3. 소통 가능 시간이 잘 안맞을 것 같아요
        </DialogContentText>
        <DialogContentText>
          4. 업무 내용이 전달한 것과 달라요
        </DialogContentText>
        <Stack spacing={1} alignItems="flex-end" sx={{ mt: 3 }}>
          {smUp && (
            <Stack direction="row" spacing={3}>
              <LoadingButton
                onClick={reject}
              >
                계약하지 않겠습니다
              </LoadingButton>
              <LoadingButton
                variant="contained"
                onClick={modify}
              >
                계약 조건을 수정할게요
              </LoadingButton>
            </Stack>
          )}
          {!smUp && (
            <Fragment>
              <LoadingButton
                fullWidth
                variant="contained"
                onClick={modify}
              >
                계약 조건을 수정할게요
              </LoadingButton>
              <LoadingButton
                fullWidth
                onClick={reject}
              >
                계약하지 않겠습니다
              </LoadingButton>
            </Fragment>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
